import { Modal } from "@tecreation/funnel-components"

import "./LinkModal.css"

export default function LinkModal({ link }) {
	return (
		<Modal className="kioskLinkModal">
			<Modal.Closer />
			<Modal.Header />
			<iframe src={link} className="h-100 w-100" />
		</Modal>
	)
}
